import React from 'react';
import {InputTextArea} from './styles';

export default ({
  dynamicSearch,
  placeholder,
  row,
  column
}: {
    row?:number;
    column?:number;
  placeholder?: string;
  inputStyle?: string;
  dynamicSearch: any;
 
}) => (

    <InputTextArea
      onChange={dynamicSearch.onChange}
      value={dynamicSearch.value}
      placeholder={placeholder}
      rows={row}
      cols={column}
    />


);
